<template>
  <div>
    <MenuMovilTP />
    <MenuMovilUni />
    <main class="container mb-4 d-lg-block d-block dkt">
      <Titulo titulo="BUSCADOR DE CARRERAS" subTitulo="UNIVERSITARIAS" />
      <FormBusqueda @buscarCarrera="buscarCarrera" />
    </main>
    <main class="container mb-4">
      <TagsBusqueda
        :vistaSeleccionada="tipoVista"
        :botonesVista="true"
        :filtro="true"
        :criteriosOrden="criterioOrdenamiento"
        @cambiarVista="cambiarVista"
        @cambiarOrden="cambiarOrden"
      />
      <b-alert dismissible v-model="showAlert" show
        >No se encontraron resultados para la búsqueda realizada...</b-alert
      >
      <VistaTarjetas
        v-show="tipoVista === 'detalle'"
        tipoFicha="CARRERA_U"
        :listadoContenido="listadoCarreras"
      />
      <VistaTabla
        v-show="tipoVista === 'lista'"
        :listadoCarreras="listadoCarreras"
      />
    </main>
    <Iconografia />
  </div>
</template>

<script>
import Titulo from "@/components/generales/paginas/TituloPagina";
import FormBusqueda from "@/components/buscadorCU/FormBusqueda";
import TagsBusqueda from "@/components/generales/paginas/TagsBusqueda";
import { mapActions, mapGetters } from "vuex";
import VistaTarjetas from "@/components/generales/paginas/VistaTarjetas";
import VistaTabla from "@/components/buscadorCU/VistaTabla";
import Iconografia from "@/components/buscadorCU/Iconografia";
import ApiUniversidades from "@/services/ApiUniversidades";
import ApiRegiones from "@/services/ApiRegiones";
import { MensajesDeCarga } from "@/utils/BusesDeEventos.js";
import Busqueda from "@/utils/Busqueda.js";
import MenuMovilTP from "@/components/generales/menuMovil/TecnicoProfesional";
import MenuMovilUni from "@/components/generales/menuMovil/AdmisionUniversitaria";
import ordenamientoMixin from "@/mixins/OrdenamientoCarreras.js";
export default {
  name: "BuscadorCU",
  components: {
    Titulo,
    FormBusqueda,
    TagsBusqueda,
    VistaTarjetas,
    VistaTabla,
    Iconografia,
    MenuMovilTP,
    MenuMovilUni
  },
  mixins: [ordenamientoMixin],
  data() {
    return {
      tipoVista: "",
      showAlert: false,
      listadoCarreras: []
    };
  },
  mounted() {
    this.tipoVista = this.vista;
    this.reiniciarBusqueda();
  },
  computed: {
    ...mapGetters(["getBusquedasAplicadas"]),
    vista() {
      return this.$store.state.vista;
    },
    criterioOrdenamiento() {
      return Busqueda.criteriosOrdenCarreraUniv();
    }
  },
  methods: {
    ...mapActions(["setVista", "setCarreras"]),
    async buscarCarrera(busqueda) {
      MensajesDeCarga.$emit("cargar");
      if (
        busqueda.region !== null ||
        busqueda.institucion !== null ||
        busqueda.carrera !== "" ||
        busqueda.jornada !== null
      ) {
        let carreras = await ApiUniversidades.getCarreras(busqueda);
        if (carreras || carreras !== "") {
          this.ordenarCarreras(carreras);
          this.showAlert = false;
        } else {
          this.setCarreras([]);
          this.listadoCarreras = [];
          this.showAlert = true;
        }
      } else {
        this.setCarreras([]);
        this.listadoCarreras = [];
      }
      MensajesDeCarga.$emit("cargado");
    },
    reiniciarBusqueda() {
      let busquedasAplicadas = this.getBusquedasAplicadas;
      let nuevaBusqueda = {
        region: null,
        institucion: null,
        carrera: "",
        jornada: null
      };
      if (busquedasAplicadas.length >= 1) {
        busquedasAplicadas.forEach(f => {
          switch (f.tipo) {
            case "REGION":
              nuevaBusqueda.region = f.filtro;
              break;
            case "INSTITUCION":
              nuevaBusqueda.institucion = f.filtro;
              break;
            case "JORNADA":
              nuevaBusqueda.jornada = f.filtro;
              break;
            case "NOMBRE_CARRERA":
              nuevaBusqueda.carrera = f.filtro;
              break;
            default:
              break;
          }
        });
        this.buscarCarrera(nuevaBusqueda);
      }
    },
    ordenarCarreras(lstadoCarreras) {
      let carreras = [];
      if (lstadoCarreras) {
        lstadoCarreras.forEach(i => {
          const instituto = {
            codigo: i.codigo,
            nombre: i.nombre,
            nombreCorto: i.nombreCorto,
            gratuidad: i.gratuidad,
            acreditado: i.acreditado,
            acreditacion: i.acreditacion,
            urlLogo: i.urlLogo,
            pantone: i.pantone,
            observacionAcreditacionCNA: i.observacionAcreditacionCNA
          };
          i.sedes.forEach(s => {
            let region = ApiRegiones.getRegionesYComunas().find(
              r => r.valorBusqueda === s.region
            );
            const sede = {
              codigo: s.codigo,
              nombre: s.nombre,
              region: region.nombreRegion
            };

            carreras.push(
              ...s.carreras.map(function(carr) {
                let carreraSimple = {};
                carreraSimple = {
                  datos: carr,
                  sede: sede,
                  institucion: instituto
                };
                return carreraSimple;
              })
            );
          });
        });
      }
      carreras = this.ordenamientoFinal(carreras);
      this.setCarreras(carreras);
      this.listadoCarreras = carreras;
    },
    ordenamientoFinal(listado) {
      let ordenado;

      let carrerasPresenciales = [];
      let carrerasNoPresenciales = [];
      listado.forEach(c => {
        const val = this.ordenModalidad.indexOf(c.datos.jornada);
        //debugger;
        if (val < 2) {
          carrerasPresenciales.push(c);
        } else {
          carrerasNoPresenciales.push(c);
        }
      });

      let ordenadoPres = this.ordenarPorCondiciones(carrerasPresenciales);
      let ordenadoNoPres = this.ordenarPorCondicionesNoPresenciales(
        carrerasNoPresenciales
      );
      ordenado = ordenadoPres.concat(ordenadoNoPres);

      return ordenado;
    },
    cambiarOrden(orden) {
      let listado = this.listadoCarreras;
      switch (orden) {
        case "NOMBRE_CARRERA_ASCENDENTE":
        case "NOMBRE_CARRERA_DESCENDENTE":
          listado.sort((a, b) => {
            let n1 = a.datos.nombre;
            let n2 = b.datos.nombre;
            if (orden === "NOMBRE_CARRERA_ASCENDENTE") {
              return n1.localeCompare(n2);
            } else {
              return n2.localeCompare(n1);
            }
          });
          break;
        case "NOMBRE_INSTITUTO_ASCENDENTE":
        case "NOMBRE_INSTITUTO_DESCENDENTE":
          listado.sort((a, b) => {
            let n1 = a.institucion.nombre;
            let n2 = b.institucion.nombre;
            if (orden === "NOMBRE_INSTITUTO_ASCENDENTE") {
              return n1.localeCompare(n2);
            } else {
              return n2.localeCompare(n1);
            }
          });
          break;
        case "ARANCEL_ASCENDENTE":
        case "ARANCEL_DESCENDENTE":
          listado.sort((a, b) => {
            let n1 = a.datos.arancelAnual;
            let n2 = b.datos.arancelAnual;
            if (orden === "ARANCEL_ASCENDENTE") {
              return n1 - n2;
            } else {
              return n2 - n1;
            }
          });
          break;
        case "DURACION_ASCENDENTE":
        case "DURACION_DESCENDENTE":
          listado.sort((a, b) => {
            let n1 = this.obtenerValorRealDuracion(
              a.datos.duracionFormalPrograma,
              a.datos.regimen
            );
            let n2 = this.obtenerValorRealDuracion(
              b.datos.duracionFormalPrograma,
              b.datos.regimen
            );
            if (orden === "DURACION_ASCENDENTE") {
              return n1 - n2;
            } else {
              return n2 - n1;
            }
          });
          break;
        default:
          break;
      }
      this.listadoCarreras = listado;
    },
    cambiarVista(valor) {
      this.tipoVista = valor;
      this.setVista(valor);
    },
    obtenerValorRealDuracion(duracion, regimen) {
      let valor = 0;
      switch (regimen) {
        case "TRIMESTRES":
          valor = duracion * 3;
          break;
        case "SEMESTRES":
          valor = duracion * 6;
          break;
        case "AÑOS":
          valor = duracion * 12;
          break;
        default:
          valor = duracion;
          break;
      }
      return valor;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/BuscadoresU/BuscadorCU.vue